import PageTitle from "@my-dld/components/PageTitle";
import React, { useContext } from "react";
import { DashboardBCItem } from "@my-dld/contexts/PageContext";
import { getNavigation } from "../utils";
import { EjariContext } from "@eres/ejari-core/contexts/EjariContext";

export default function ( props: { title: string } ) {
	const { title } = props;
	const ctx = useContext( EjariContext );
	let paths = [ DashboardBCItem, ...getNavigation( ctx ) ];
	return <PageTitle
		title={ title }
		paths={ paths }/>;
}
